import React from 'react';
import { midas } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
const Chip = ({ children, close = false, round = false, disabled = false, active = false, onClose, dataCy, }) => (React.createElement("div", { className: classNames(midas.chip, disabled && midas.disabled, active && midas.active, close && midas.chipClose, round && midas.chipRound) },
    React.createElement("span", { "data-cy": dataCy }, children),
    close && React.createElement("button", { type: "button", onClick: (e) => onClose === null || onClose === void 0 ? void 0 : onClose(e) })));
export default Chip;
